import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

import { apiRequest } from '@/src/services';

const ResetPasswordForm: React.FC = () => {
    const [params] = useSearchParams();
    const token = params.get('token') || '';

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setMessage('');

        if (!token) {
            setMessage('Invalid or missing token.');
            return;
        }

        if (password !== confirm) {
            setMessage('Passwords do not match.');
            return;
        }

        try {
            setLoading(true);
            await apiRequest('POST', 'dbo/users/password/resetPasswordEmail', {
                token,
                newPassword: password,
            });
            setMessage('Password reset successful! Redirecting to login...');
            setTimeout(() => navigate('/login'), 2000); // redirect after 2 seconds
        } catch (err: any) {
            console.error(err);
            setMessage('Password reset failed. The link may have expired.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <div className="reset-password-wrapper">
                <label className="reset-password-label">
                    New Password:
                    <input
                        type="password"
                        className="reset-password-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </label>
                <label className="reset-password-label">
                    Confirm Password:
                    <input
                        type="password"
                        className="reset-password-input"
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        required
                    />
                </label>
                <button
                    type="submit"
                    style={{
                        padding: '12px 20px',
                        borderRadius: 6,
                        background: 'var(--pm-primary)',
                        color: '#fff',
                        border: 'none',
                        fontSize: 16,
                        marginTop: 8,
                    }}
                    disabled={loading}
                >
                    {loading ? 'Saving...' : 'Reset Password'}
                </button>

                {message && (
                    <div
                        style={{
                            color: message.includes('successful') ? 'green' : 'red',
                            marginTop: 16,
                            textAlign: 'center',
                        }}
                    >
                        {message}
                    </div>
                )}
            </div>
        </form>
    );
};

export default ResetPasswordForm;
